/**
 * @generated SignedSource<<c9f44ce1ab578b14064ac15317df31bb>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateCurrentPasswordLoginPayload",
            "kind": "LinkedField",
            "name": "updateCurrentUserPassword",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "success",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserPasswordUpdateModal_updateCurrentUserPasswordMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserPasswordUpdateModal_updateCurrentUserPasswordMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "85402886096ba5d276caac6f42e31270",
            "id": null,
            "metadata": {},
            "name": "UserPasswordUpdateModal_updateCurrentUserPasswordMutation",
            "operationKind": "mutation",
            "text": "mutation UserPasswordUpdateModal_updateCurrentUserPasswordMutation(\n  $model: UpdateCurrentUserPasswordRequestInput!\n) {\n  updateCurrentUserPassword(model: $model) {\n    success\n  }\n}\n"
        }
    };
})();
node.hash = "79f9296c628aa1b74622ee8698cac022";
export default node;
